import type { ComponentProps } from 'react'
import { cn } from '../lib/cn'
import { Media } from './media'
import { Heading } from './typography'
export function Card({
  className,
  appearance = 'outlined',
  padding = 'md',
  ...props
}: ComponentProps<'section'> & {
  appearance?: 'plain' | 'outlined' | 'elevated'
  padding?: 'none' | 'sm' | 'md'
}) {
  return (
    <section
      {...props}
      data-slot="card"
      className={cn(
        'min-w-0 rounded-panel bg-card',
        appearance !== 'plain' && 'border border-border',
        appearance === 'elevated' && 'shadow-surface',
        padding === 'md' && 'p-5',
        padding === 'sm' && 'p-4',
        className,
      )}
    />
  )
}
export function CardHeader({
  className,
  appearance = 'plain',
  ...props
}: ComponentProps<'div'> & { appearance?: 'plain' | 'strip' }) {
  return (
    <div
      {...props}
      data-slot="card-header"
      className={cn(
        'flex flex-wrap justify-between gap-3',
        appearance === 'strip'
          ? 'items-center border-b border-border px-5 py-4'
          : 'mb-4 items-start',
        className,
      )}
    />
  )
}
export function CardTitle({ className, ...props }: ComponentProps<typeof Heading>) {
  return <Heading as="h3" size="sm" {...props} data-slot="card-title" className={cn(className)} />
}
export function CardDescription({ className, ...props }: ComponentProps<'p'>) {
  return <p {...props} className={cn('mt-1 text-sm leading-6 text-muted-foreground', className)} />
}
export function CardBody({ className, ...props }: ComponentProps<'div'>) {
  return <div {...props} data-slot="card-body" className={cn('min-w-0', className)} />
}
export function CardFooter({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      {...props}
      data-slot="card-footer"
      className={cn('mt-5 flex flex-wrap items-center gap-3', className)}
    />
  )
}
export function CardMedia({ className, ...props }: ComponentProps<typeof Media>) {
  return <Media {...props} className={cn('rounded-t-panel', className)} />
}
